// src/pages/News/News.js

import React, { useMemo } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import newsData from "../../data/newsData";
import { sortNewsByLatest } from "../../utils/newsHelpers";
import NewsCard from "../../components/cards/NewsCard/NewsCard";
import "./NewsPage.css";

export default function NewsPage() {
    const { i18n } = useTranslation();
    const isArabic = i18n.language?.startsWith("ar");

    const allNews = useMemo(() => sortNewsByLatest(newsData), []);

    const { t } = useTranslation();

    return (
        <section className="news-page">

            <div className="newsPageBanner text-center">
                <div className="page-banner-content">
                    <h3>{t("newsPage.bannerSubtitle")}</h3>
                    <h1>{t("newsPage.bannerTitle")}</h1>
                </div>
            </div>
            <Container>
                <div className="news-page__list-wrap">
                    <div className="news-page__list">
                        {allNews.map((item) => (
                            <div key={item.id} className="news-page__list-item">
                                <NewsCard item={item} layout="list" />
                            </div>
                        ))}
                    </div>
                </div>


            </Container>
        </section>
    );
}